// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_oo-0";